module.exports = __webpack_public_path__ + "media/hyper/images/layouts/layout-1-173bfb6d7f450c82fca24a544759296f.png";